import axios from './axios'
import config from '../config'

export default {
    listProjects(params) {
        return axios({
            url: config.backendUrl + '/op/admin/projects',
            method: 'GET',
            params
        })
    },
    addProject(data) {
        return axios({
            url: config.backendUrl + '/op/admin/projects',
            method: 'POST',
            data
        })
    },
    updateProject({id, data}) {
        return axios({
            url: config.backendUrl + '/op/admin/projects/' + id,
            method: 'PUT',
            data
        })
    },
    getProject(id) {
        return axios({
            url: config.backendUrl + '/op/admin/projects/' + id,
            method: 'GET'
        })
    },
    deleteProject(id) {
        return axios({
            url: config.backendUrl + '/op/admin/projects/' + id,
            method: 'DELETE'
        })
    },
    checkProjectName(name) {
        return axios({
            url: config.backendUrl + '/op/admin/projects/check-name',
            method: 'GET',
            params: {name}
        })
    },
    checkProjectAdminName(name) {
        return axios({
            url: config.backendUrl + '/op/admin/projects/check-admin-name',
            method: 'GET',
            params: {name}
        })
    }
}
